
export default {
  props: {
    stats: {
      type: Array,
      required: true,
    },
    titles: {
      type: Array,
      required: true,
    },
    legendTitles: {
      type: Array,
      required: true,
    },
    maxTypePercent: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      options: {
        legend: {
          left: `center`,
        },
        tooltip: {
          trigger: `item`,
          triggerOn: `click`,
        },
        radar: {
          indicator: [],
          center: [`50%`, `50%`],
          radius: [4, `50%`], // Radius of Chart,
          axisName: {
            color: `#000000`,
          },
          splitArea: {
            areaStyle: {
              color: [`#D6D6D6`, `#FFFFFF`],
            },
          },
        },
        series: {
          type: `radar`,
          tooltip: {
            trigger: `item`,
          },
          areaStyle: {},
          data: [],
        },
      },
    };
  },
  computed: {
    ariaLabel () {
      const teamTexts = [];
      for (let i = 0; i < this.stats.length; i++) {
        const teamName = this.stats[i].name;
        const stats = [];
        for (let j = 0; j < this.stats[i].value.length; j++) {
          stats.push(`${this.titles[j]} ${this.stats[i].value[j]}`);
        }
        teamTexts.push(`${teamName}: ${stats.join(`, `)}`);
      }
      return `Radar chart showing: ${teamTexts.join(`. `)}`;
    },
    largestValue () {
      const allValues = [];
      for (const stat of this.stats) {
        allValues.push(...stat.value);
      }
      return Math.max(...allValues);
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getData();
    });
  },
  methods: {
    getData () {
      const titles = [];
      for (const title of this.titles) {
        const titleArr = title.split(` `).map(word => `${word} `);
        titleArr.splice(2, 0, `\n`);
        titles.push(titleArr.join(``));
      }

      this.options.radar.indicator = titles.map(title => ({
        name: title,
        max: this.maxTypePercent ? 100 : this.largestValue + 2,
      }));
      this.options.series.data = this.stats.map((stat, index) => ({
        ...stat,
        itemStyle: {
          color: this.radarColours[index],
        },
      }));
      this.options.legend.data = this.legendTitles;
    },
  },
};
